import type { BusinessMenuItemDetails } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'menu/items/business';

export function getInventoryData(query?: BusinessMenuItemDetails.SearchQuery) {
    return api.get<BusinessMenuItemDetails.InventorySearchResponse>(
        `${rootPath}/inventory`,
        query
    );
}
